export default "__VITE_ASSET__BuKzr6ox__"